import React from 'react';
import { AJAX_SPINNER } from '../constants/test-ids';
import flex from '../css/module/flex.css';
import css from '../css/module/new-world.css';

export type AjaxSpinnerProps = {
  small?: boolean;
  className?: string;
  message?: string;
  center?: string;
};

const AjaxSpinner: React.FC<AjaxSpinnerProps> = ({
  small,
  center,
  message,
  className,
}) => {
  const clz = `${className || ''} ${small ? 'ajaxLoaderSmall' : ''} ${
    center ? flex.middle : ''
  }`;
  return (
    <div
      className={`${clz} ${flex.column} ${flex.alignItemsCenter}`}
      data-testid={AJAX_SPINNER}
    >
      {/* CSS spinner below uses a div for each notch in the spinner */}
      <div className="ldsSpinner">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      {message && (
        <div className={`${css.loadingMessage} box-shadow`}>{message}</div>
      )}
    </div>
  );
};

export default AjaxSpinner;
